/**
 * Buy Crypto nav submenu (UserHeader + Footer Services).
 */
export const BUY_CRYPTO_SUBMENU_ITEMS = [
  {
    id: "buy_crypto",
    title: "Buy Crypto",
    titleSub: "Hot",
    desc: "Buy USDT with AED from your spot wallet",
    to: "/buy_crypto?side=buy&asset=USDT",
    iconSrc: "/images/buy_icon_menu.svg",
  },
  {
    id: "p2p",
    title: "P2P",
    titleSub: "0 Fees",
    desc: "Zero fees with direct user-to-user transactions",
    to: "/coming_soon",
    iconSrc: "/images/p2p_icon_menu.svg",
  },
];
